
import { Component, Vue, Watch } from "vue-property-decorator";
import { VuetifyForm } from "@/plugins/vuetify";
import FormService from "@/services/FormService";
import Loading from "@/components/app/Loading.vue";
@Component({
  components: { Loading }
})
export default class LoginView extends Vue {
  valid = false;
  email = "";
  password = "";

  otpValid = false;

  otpFormatRule = (v: string) => /^[0-9]{8,20}$/.test(v) || "Invalid Code";


  emailRules = [FormService.requiredStringRule, FormService.emailFormatRule];

  passwordRules = [this.otpFormatRule];


  waitingForOTP = false;

  loading = false;

  get form() {
    return this.$refs.form as VuetifyForm;
  }

  get otpForm() {
    return this.$refs.otpForm as VuetifyForm;
  }


  async mounted() {
    if (await this.$store.getters.isLoggedIn()) {
      await this.$store.dispatch("loading");
      if (this.userIsSet) await this.checkLoggedIn();
    }
  }

  async completeChallenge(){
    await this.otpForm.validate();
    if (this.otpValid) {
      try {
        await this.$store.dispatch("loading");
         await this.$store.dispatch("awsCognitoCompleteChallenge", {
          password: this.password});
        this.password = "";
        await this.checkLoggedIn();
      } catch (error) {
        if(error.message === "Too many failed attempts, try again.") {
          this.waitingForOTP = false;
        }
        await this.$store.dispatch("error", error.message);
        this.password = ""
      }
    }
    await this.$store.dispatch("clearLoading");
    console.log("END complete challenge")
  }

  async doLogin() {
    await this.form.validate();
    if (this.valid) {
      try {
        await this.$store.dispatch("loading");
        await this.$store.dispatch("awsCognitoLogin", {
          username: this.email
        });
        this.waitingForOTP = true;
      } catch (error) {
        if(error.message!=null && error.message.includes("EMAIL_NOT_FOUND"))
          await this.$store.dispatch("error", "Email address not found");
        else
          await this.$store.dispatch("error", "Something went wrong, please try again later");
        }
      }
      await this.$store.dispatch("clearLoading");
      this.password = "";
    }

  get userIsSet() {
    return this.$store.getters.getUser != null;
  }

  @Watch("userIsSet")
  async checkLoggedIn() {
    if (
      (await this.$store.getters.isLoggedIn()) &&
      this.$route.name === "Login"
    ) {
      try {
        console.log("Pushing Home");
        await this.$router.push("/");
      } catch (error) {
        console.log("Cant push Home");
      }
    }
  }

}
